import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropertySearch from '../components/PropertySearch';
import { api } from '../lib/api';
import type { State, Area } from '../types';

export default function PropertiesByLocation() {
  const { location } = useParams();
  const [stateSlug, setStateSlug] = useState<string | undefined>();
  const [areaSlug, setAreaSlug] = useState<string | undefined>();
  const [title, setTitle] = useState<string>('');
  const formattedLocation = location?.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

  useEffect(() => {
    let mounted = true;
    Promise.all([api.get<State[]>('/states'), api.get<Area[]>('/areas')])
      .then(([states, areas]) => {
        if (!mounted || !location) return;
        const state = states.find((s) => s.slug === location);
        const area = areas.find((a) => a.slug === location);
        if (state) {
          setStateSlug(state.slug);
          setAreaSlug(undefined);
          setTitle(`Properties in ${state.name}`);
        } else if (area) {
          setAreaSlug(area.slug ?? undefined);
          setStateSlug(undefined);
          setTitle(`Properties in ${area.name}${area.state_name ? `, ${area.state_name}` : ''}`);
        } else {
          setStateSlug(undefined);
          setAreaSlug(undefined);
          setTitle(`Properties in ${formattedLocation}`);
        }
      })
      .catch(() => {
        if (mounted) setTitle(`Properties in ${formattedLocation}`);
      });
    return () => { mounted = false; };
  }, [location, formattedLocation]);

  return (
    <PropertySearch
      stateSlug={stateSlug}
      areaSlug={areaSlug}
      title={title || `Properties in ${formattedLocation}`}
      subtitle="Browse our exclusive listings in this location"
    />
  );
}
